import React from 'react';
import { Chip, Colors } from 'library';
import { Grid } from '@mui/material';
import { IProviderReviewOption } from 'models';

export default function ReviewOptionSelect({
    options,
    value,
    onChange,
    isScorePositive,
    isScoreNeutral,
}: {
    options: IProviderReviewOption[];
    value: number[];
    onChange: (newVal: number[]) => void;
    isScorePositive?: boolean | 0;
    isScoreNeutral?: boolean | 0;
}) {
    const optionSelected = (option: IProviderReviewOption) => value && value.includes(option.id);
    const onToggle = (option: IProviderReviewOption) => {
        onChange(optionSelected(option) ? value.filter((it) => it !== option.id) : [...value, option.id]);
    };

    function getBackgroundColor(value: boolean) {
        if (isScoreNeutral) {
            return value ? Colors.darkNavy : Colors.lightGrey;
        }

        return value ? (isScorePositive ? Colors.turquoise : Colors.mediumRed) : Colors.lightGrey;
    }

    return (
        <Grid direction="row" container justifyContent="left" gap={1}>
            {options.map((option) => (
                <Chip
                    key={option.id}
                    backgroundColor={getBackgroundColor(optionSelected(option))}
                    onClick={() => onToggle(option)}
                    label={option.text}
                    textColor={Colors.white}
                />
            ))}
        </Grid>
    );
}
